import { gql } from '@apollo/client';

export const ARCHIVE_PRAYER_MEETING = gql`
    mutation ArchivePrayerMeeting($id: Int!, $supportedOrganisationId: Int!) {
        archivePrayerMeeting(id: $id, supportedOrganisationId: $supportedOrganisationId) {
            id
        }
    }
`;
